(ns ui.editors.card.sub
  (:require [re-frame.core :as rf]
            [ui.state.session.sub :as session-sub]
            [ui.editors.card.model :as model]
            [common.localization :as loc]
            [common.schema.entities.card :as card-schema]
            [ui.editors.card.property-list.model :as property-list-model]
            [common.entity :as entity]))

(rf/reg-sub
 ::editor-state
 (fn [db _]
   (get-in db model/root-path)))

(rf/reg-sub
 ::initialized?
 :<- [::editor-state]
 (fn [editor-state]
   (get-in editor-state model/initialized-path)))

(rf/reg-sub
 ::submitting?
 :<- [::editor-state]
 (fn [editor-state]
   (get-in editor-state model/submitting-path)))

(rf/reg-sub
 ::card
 :<- [::editor-state]
 (fn [editor-state]
   (get-in editor-state model/card-path)))

(rf/reg-sub
 ::original-card
 :<- [::editor-state]
 (fn [editor-state]
   (get-in editor-state model/original-card-path)))

(rf/reg-sub
 ::changes?
 :<- [::card]
 :<- [::original-card]
 (fn [[current-card original-card]]
   (not= (card-schema/select-updatable-fields current-card)
         (card-schema/select-updatable-fields original-card))))

(rf/reg-sub
 ::card-title
 :<- [::card]
 (fn [card]
   (:card/title card)))

(rf/reg-sub
 ::card-description
 :<- [::card]
 (fn [card]
   (:card/description card)))

(rf/reg-sub
 ::card-type
 :<- [::card]
 (fn [card]
   (:card/type card)))

(rf/reg-sub
 ::card-config
 :<- [::card]
 (fn [card]
   (:card/config card)))

(rf/reg-sub
 ::entity-type
 :<- [::editor-state]
 (fn [card-state]
   (get-in card-state model/entity-type-path)))

(rf/reg-sub
 ::show-modal?
 :<- [::editor-state]
 (fn [editor-state]
   (get-in editor-state model/show-modal-path)))

(rf/reg-sub
 ::create-new-card?
 :<- [::editor-state]
 (fn [editor-state]
   (get-in editor-state model/create-new-card-path)))

(rf/reg-sub
 ::update-card?
 :<- [::editor-state]
 (fn [editor-state]
   (get-in editor-state model/update-card-path)))

(rf/reg-sub
 ::current-tab
 :<- [::editor-state]
 (fn [editor-state]
   (get-in editor-state model/current-tab-path)))

(rf/reg-sub
 ::preview-card-default-width
 :<- [::editor-state]
 (fn [editor-state]
   (get-in editor-state model/preview-card-default-width-path)))

(rf/reg-sub
 ::preview-entity-options
 :<- [::editor-state]
 :<- [::session-sub/entity-types]
 (fn [[editor-state entities-by-type]]
   (let [entity-type (get-in editor-state model/entity-type-path)
         entities-for-type (get entities-by-type entity-type)
         options (->> entities-for-type
                      (mapv (fn [entity]
                              {:label (entity/display-string entity)
                               :value (:db/id entity)}))
                      (sort-by :label))]
     options)))

(rf/reg-sub
 ::preview-entity-id
 :<- [::editor-state]
 (fn [editor-state]
   (get-in editor-state model/preview-entity-id-path)))

(rf/reg-sub
 ::validation-error
 :<- [::card]
 (fn [card]
   (let [card-type (:card/type card)]
     (case card-type
       :card.type/property-list (property-list-model/validate-card card)
       nil))))

(rf/reg-sub
 ::submit-button-state
 :<- [::create-new-card?]
 :<- [::update-card?]
 :<- [::submitting?]
 :<- [::changes?]
 :<- [::validation-error]
 (fn [[create-new-card? update-card? submitting? changes? validation-error]]
   (let [label (loc/tr :done)
         submit-action-type (cond create-new-card? :create
                                  update-card? :update)
         disabled? (or submitting?
                       validation-error
                       (and update-card?
                            (not changes?)))
         tooltip-label (cond
                         validation-error
                         (:message validation-error)

                         (and update-card? (not changes?))
                         (loc/tr :no-changes)
                         :else nil)]
     {:label label
      :disabled? disabled?
      :submitting? submitting?
      :tooltip-label tooltip-label
      :submit-action-type submit-action-type})))

